var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "jp-common-layout page" }, [
    _c("div", { staticClass: "jp-common-layout-left" }, [
      _c(
        "div",
        { staticClass: "jp-common-title" },
        [
          _c(
            "el-button",
            {
              staticStyle: { width: "100%" },
              attrs: { size: "small", type: "primary" },
              on: { click: _vm.sendLetter },
            },
            [_vm._v("写信")]
          ),
        ],
        1
      ),
      _c("div", { staticClass: "jp-common-el-tree-scrollbar el-scrollbar" }, [
        _c("div", { staticClass: "el-scrollbar__wrap" }, [
          _c(
            "div",
            { staticClass: "el-scrollbar__view" },
            [
              _c(
                "el-menu",
                { staticStyle: { border: "0" }, on: { select: _vm.select } },
                [
                  _c(
                    "el-menu-item-group",
                    [
                      _c("template", { slot: "title" }, [_vm._v("我的信箱")]),
                      _c("el-menu-item", { attrs: { index: "1" } }, [
                        _vm._v(
                          "收件箱 (" +
                            _vm._s(" " + _vm.noReadCount) +
                            "/" +
                            _vm._s(_vm.mailBoxCount + " ") +
                            ")"
                        ),
                      ]),
                      _c("el-menu-item", { attrs: { index: "2" } }, [
                        _vm._v(
                          "已发送 (" +
                            _vm._s(" " + _vm.mailComposeCount + " ") +
                            ")"
                        ),
                      ]),
                      _c("el-menu-item", { attrs: { index: "3" } }, [
                        _vm._v(
                          "草稿箱 (" +
                            _vm._s(" " + _vm.mailDraftCount + " ") +
                            ")"
                        ),
                      ]),
                      _c("el-menu-item", { attrs: { index: "4" } }, [
                        _vm._v(
                          "已删除 (" +
                            _vm._s(" " + _vm.mailTrashCount + " ") +
                            ")"
                        ),
                      ]),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "jp-common-layout-center jp-flex-main" },
      [
        _c(
          "el-form",
          {
            ref: "searchForm",
            staticClass: "query-form",
            attrs: { size: "small", inline: true, model: _vm.searchForm },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.refreshList()
              },
              submit: function ($event) {
                $event.preventDefault()
              },
            },
          },
          [
            _c(
              "el-form-item",
              [
                _c(
                  "el-dropdown",
                  { on: { command: _vm.changeReadStatus } },
                  [
                    _c(
                      "el-button",
                      { attrs: { size: "small", type: "primary" } },
                      [
                        _vm._v(" 过滤"),
                        _c("i", {
                          staticClass: "el-icon-arrow-down el-icon--right",
                        }),
                      ]
                    ),
                    _c(
                      "el-dropdown-menu",
                      { attrs: { slot: "dropdown" }, slot: "dropdown" },
                      [
                        _c("el-dropdown-item", { attrs: { command: "0" } }, [
                          _vm._v("未读"),
                        ]),
                        _c("el-dropdown-item", { attrs: { command: "1" } }, [
                          _vm._v("已读"),
                        ]),
                        _c("el-dropdown-item", { attrs: { command: "" } }, [
                          _vm._v("全部"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-form-item",
              [
                _c(
                  "el-button",
                  {
                    attrs: { size: "small", type: "primary" },
                    on: { click: _vm.refreshList },
                  },
                  [_c("i", { staticClass: "el-icon-refresh" })]
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "danger",
                      size: "small",
                      icon: "el-icon-delete",
                      plain: "",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.del()
                      },
                    },
                  },
                  [_vm._v("删除 ")]
                ),
              ],
              1
            ),
            _c("el-form-item"),
            _c(
              "el-form-item",
              { staticClass: "pull-right" },
              [
                _c(
                  "el-input",
                  {
                    attrs: { placeholder: "请输入标题" },
                    model: {
                      value: _vm.searchForm.mailDTO.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm.mailDTO, "title", $$v)
                      },
                      expression: "searchForm.mailDTO.title",
                    },
                  },
                  [
                    _c("el-button", {
                      attrs: { slot: "append", icon: "el-icon-search" },
                      on: { click: _vm.refreshList },
                      slot: "append",
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "bg-white top" },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                staticClass: "table",
                attrs: {
                  data: _vm.dataList,
                  size: "small",
                  height: "calc(100% - 50px)",
                },
                on: {
                  "selection-change": _vm.selectionChangeHandle,
                  "sort-change": _vm.sortChangeHandle,
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    type: "selection",
                    "header-align": "center",
                    align: "center",
                    width: "50",
                  },
                }),
                _vm.index === "2" || _vm.index === "3" || _vm.index === "4"
                  ? _c("el-table-column", {
                      attrs: { prop: "status", label: "状态" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.status === "1"
                                  ? _c(
                                      "el-tag",
                                      { attrs: { type: "success" } },
                                      [_vm._v("已发送")]
                                    )
                                  : _vm._e(),
                                scope.row.status === "0"
                                  ? _c(
                                      "el-tag",
                                      { attrs: { type: "danger" } },
                                      [_vm._v("草稿")]
                                    )
                                  : _vm._e(),
                                scope.row.status === "2"
                                  ? _c(
                                      "el-tag",
                                      { attrs: { type: "danger" } },
                                      [_vm._v("未读")]
                                    )
                                  : _vm._e(),
                                scope.row.status === "3"
                                  ? _c(
                                      "el-tag",
                                      { attrs: { type: "success" } },
                                      [_vm._v("已读")]
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1837862968
                      ),
                    })
                  : _vm._e(),
                _vm.index === "1"
                  ? _c("el-table-column", {
                      attrs: { prop: "readStatus", label: "状态" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.readStatus === "1"
                                  ? _c(
                                      "el-tag",
                                      { attrs: { type: "success" } },
                                      [_vm._v("已读")]
                                    )
                                  : _vm._e(),
                                scope.row.readStatus === "0"
                                  ? _c(
                                      "el-tag",
                                      { attrs: { type: "danger" } },
                                      [_vm._v("未读")]
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1458375605
                      ),
                    })
                  : _vm._e(),
                _vm.index === "1" || _vm.index === "4"
                  ? _c("el-table-column", {
                      attrs: { prop: "sender.name", label: "发件人" },
                    })
                  : _vm._e(),
                _vm.index !== "1" || _vm.index === "4"
                  ? _c("el-table-column", {
                      attrs: { prop: "receiverNames", label: "收件人" },
                    })
                  : _vm._e(),
                _c("el-table-column", {
                  attrs: {
                    prop: "mailDTO.title",
                    "show-overflow-tooltip": "",
                    label: "标题",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    "show-overflow-tooltip": "",
                    prop: "sendTime",
                    label: "时间",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    "header-align": "center",
                    align: "center",
                    width: "210",
                    label: "操作",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "text",
                                size: "mini",
                                icon: "el-icon-view",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.view(scope.row.id)
                                },
                              },
                            },
                            [_vm._v("查阅 ")]
                          ),
                          _vm.index === "1"
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "text",
                                    icon: "el-icon-edit",
                                    size: "mini",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.reply(scope.row)
                                    },
                                  },
                                },
                                [_vm._v(" 回复 ")]
                              )
                            : _vm._e(),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "text",
                                icon: "el-icon-delete",
                                size: "mini",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.del(scope.row.id)
                                },
                              },
                            },
                            [_vm._v(" 删除 ")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _c("el-pagination", {
              attrs: {
                "current-page": _vm.pageNo,
                "page-sizes": [10, 20, 50, 100],
                "page-size": _vm.pageSize,
                total: _vm.total,
                background: "",
                layout: "total, sizes, prev, pager, next, jumper",
              },
              on: {
                "size-change": _vm.sizeChangeHandle,
                "current-change": _vm.currentChangeHandle,
              },
            }),
          ],
          1
        ),
        _c("SendEmail", {
          ref: "sendEmail",
          on: { refreshList: _vm.refreshList },
        }),
        _c("SentMailDetail", {
          ref: "sentMailDetail",
          on: { refreshList: _vm.refreshList },
        }),
        _c("ReceivedMailDetail", {
          ref: "receivedMailDetail",
          on: { refreshList: _vm.refreshList },
        }),
        _c("TrashMailDetail", {
          ref: "trashMailDetail",
          on: { refreshList: _vm.refreshList },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }